import { useState } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	FormControlLabel,
	Checkbox,
	Typography,
	Box,
	Alert,
} from '@mui/material'
import { Warning } from '@mui/icons-material'

export function DeleteConfirmationDialog({ open, onClose, onConfirm, title, itemName, itemType }) {
	const [confirmText, setConfirmText] = useState('')
	const [acknowledged, setAcknowledged] = useState(false)

	const isValid = confirmText.toLowerCase() === 'delete' && acknowledged

	const handleClose = () => {
		setConfirmText('')
		setAcknowledged(false)
		onClose()
	}

	const handleConfirm = () => {
		if (isValid) {
			onConfirm()
			handleClose()
		}
	}

	const handleKeyPress = (e) => {
		if (e.key === 'Enter' && isValid) {
			handleConfirm()
		}
	}

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<Box display="flex" alignItems="center" gap={1}>
					<Warning color="error" />
					<Typography variant="h6" component="span">
						{title}
					</Typography>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Alert severity="error" sx={{ mb: 3 }}>
					<Typography variant="body2" fontWeight="bold" gutterBottom>
						This action cannot be undone!
					</Typography>
					<Typography variant="body2">
						{itemType === 'customer' 
							? 'Deleting this customer will permanently remove all associated sensors, measurements, and configuration data.'
							: 'Deleting this sensor will permanently remove all associated measurements and configuration data.'}
					</Typography>
				</Alert>

				<Typography variant="body1" gutterBottom>
					You are about to delete:
				</Typography>
				<Typography variant="h6" color="error" gutterBottom sx={{ mb: 3 }}>
					{itemName}
				</Typography>

				<FormControlLabel
					control={
						<Checkbox
							checked={acknowledged}
							onChange={(e) => setAcknowledged(e.target.checked)}
							color="error"
						/>
					}
					label={
						<Typography variant="body2">
							I understand that this action is permanent and cannot be reversed
						</Typography>
					}
					sx={{ mb: 2 }}
				/>

				<TextField
					fullWidth
					label="Type 'delete' to confirm"
					value={confirmText}
					onChange={(e) => setConfirmText(e.target.value)}
					onKeyPress={handleKeyPress}
					placeholder="delete"
					helperText="Type the word 'delete' (case insensitive)"
					error={confirmText.length > 0 && confirmText.toLowerCase() !== 'delete'}
					autoFocus
				/>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={handleClose} variant="outlined">
					Cancel
				</Button>
				<Button
					onClick={handleConfirm}
					variant="contained"
					color="error"
					disabled={!isValid}
				>
					Delete Permanently
				</Button>
			</DialogActions>
		</Dialog>
	)
}
